'use client';

import { useSite } from 'src/context/providers/SiteProvider';
import { CompanyAdminActionTypes } from 'src/context/reducers/actionTypes';
import { useCallback } from 'react';

/**
 * @description Simplified hook to manage user selection state
 * @returns Selected users state and setter functions for both bulk and single user selection
 */
const useSettings = () => {
  const { dispatch, state } = useSite();

  const setSelectedUsers = useCallback(
    (newSelectedUsers: MedScout.User[]) => {
      dispatch({
        type: CompanyAdminActionTypes.SET_SELECTED_USERS,
        payload: newSelectedUsers,
      });
    },
    [dispatch]
  );

  const setSelectedUser = useCallback(
    (user: MedScout.User | null) => {
      dispatch({
        type: CompanyAdminActionTypes.SET_SELECTED_USER,
        payload: user,
      });
    },
    [dispatch]
  );

  return {
    selectedUsers: state.companyAdmin.selectedUsers,
    setSelectedUsers,
    selectedUser: state.companyAdmin.selectedUser,
    setSelectedUser,
  };
};

export default useSettings;
